import { render, staticRenderFns } from "./PoultryHouseVisitSelectionPanel.vue?vue&type=template&id=48c2b7b4&scoped=true&"
import script from "./PoultryHouseVisitSelectionPanel.vue?vue&type=script&lang=js&"
export * from "./PoultryHouseVisitSelectionPanel.vue?vue&type=script&lang=js&"
import style0 from "./PoultryHouseVisitSelectionPanel.vue?vue&type=style&index=0&id=48c2b7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c2b7b4",
  null
  
)

export default component.exports